<div class="title-bar">
    <h2 class="title-text" mat-dialog-title>{{title}}</h2>
</div>